import styled from 'styled-components'
import { CircularProgress } from '@mui/material'

interface Props {
  size?: number
  className?: string
}

export default function LoadingSpinner({ size, className }: Props): JSX.Element {
  return <Spinner size={size || 24} className={className} />
}

const Spinner = styled(CircularProgress)`
  color: ${(props) => props.theme.customPalette.light};
`
